module.exports = __webpack_public_path__ + "public/img/gzhxx.3faeabd8.png";